import { loadScript } from '@/utils/loadScript'
import { AWIN_ID } from '@/config'

const loadAwin = () => {
  loadScript({ src: `https://www.dwin1.com/${AWIN_ID}.js` })
}

export default loadAwin
